/* eslint-disable import/prefer-default-export */
import fontStyles from '@shared/design-tokens/fontStyles';
import { ButtonProps } from './types';

export const buttonStyle = (isSmall: boolean, shape: ButtonProps['shape'], color: ButtonProps['color'], ignoreDisabledColor?: boolean) => {
  const roundRadius = `${isSmall ? 8 : 24}px`;
  const borderRadius = shape === 'round' ? roundRadius : '4px';
  const paddingVertically = isSmall ? 4 : 12;
  const paddingHorizontal = isSmall ? 8 : 24;
  const backgroundHover = shape === 'square' ? `${color}.light` : 'white';
  const minHeight = isSmall ? '24px' : '48px';
  return ({
    paddingLeft: `${paddingHorizontal}px !important`,
    paddingRight: `${paddingHorizontal}px !important`,
    borderRadius,
    display: 'flex',
    textTransform: 'unset !important',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: `${paddingVertically}px !important`,
    paddingBottom: `${paddingVertically}px !important`,
    minWidth: {
      xs: '100%',
      sm: '100%',
      md: '91px',
    },
    minHeight,
    border: '2px solid transparent',
    ...(isSmall ? fontStyles.core.textSmallMedium : fontStyles.core.textExtraSmallMedium),
    '&.MuiButton-text': {
      '&.Mui-disabled, &.__disabled': {
        color: ignoreDisabledColor ? 'inherit' : '', // Optionally maintain text color
        // Other styles for disabled state can go here
      },
    },
    '&.MuiButton-outlined': {
      border: 1,
      borderColor: shape === 'square' ? `${color}.light` : `${color}.main`,
      '&:hover, &.__hover': {
        paddingLeft: `${paddingHorizontal - 1}px !important`,
        paddingRight: `${paddingHorizontal - 1}px !important`,
        backgroundColor: `${backgroundHover} !important`,
        color: `${color}.main`,
        borderColor: `${color}.main`,
        border: 2,
      },
      '&.Mui-disabled, &.__disabled': {
        borderColor: 'rgba(0,0,0,0.12)',
      },
    },
    '&.MuiButton-contained': {
      border: 2,
      borderColor: `${color}.main`,
      color: 'white',
      '&:hover, &.__hover': {
        paddingLeft: `${paddingHorizontal}px !important`,
        paddingRight: `${paddingHorizontal}px !important`,
        backgroundColor: `${backgroundHover} !important`,
        color: `${color}.main`,
        borderColor: `${color}.main`,
        border: 2,
      },
      '&.Mui-disabled, &.__disabled': {
        paddingLeft: `${paddingHorizontal + 1}px !important`,
        paddingRight: `${paddingHorizontal + 1}px !important`,
        minWidth: '91px',
        minHeight,
        border: 0,
      },
    },
    '.MuiLoadingButton-startIconLoadingStart': {
      marginRight: '10px',
    },
    '.MuiLoadingButton-endIconLoadingEnd': {
      marginLeft: '10px',
    },
    '.MuiCircularProgress-root': {
      marginRight: '8px',
      marginLeft: '8px',
    },
    '.MuiButton-endIcon': {
      marginRight: '-8px',
    },
    '.MuiButton-startIcon': {
      marginLeft: '-8px',
    },
  });
};

export const noPaddingStyle = (
  preventBtnPadding = false,
  color: ButtonProps['color'],
  variant: ButtonProps['variant']
): any => {
  return preventBtnPadding
    ? {
        padding: '0px !important',
        backgroundColor: 'transparent !important',
        color: `${color}.main`,
        minHeight: 'auto !important',
        border: '0px !important',
        borderRadius: '0px !important',
        transition: 'none !important',
        '.MuiButton-startIcon': {
          marginLeft: '0px',
        },
      }
    : {};
};